import type { OASISFormData } from './types';

/**
 * Questions the form asks whose answers are not chart answers.
 *
 * Where care was provided, the HCPCS code override and the mileage are kept on
 * the visit itself, in Task Details, so they stay editable after the note is
 * signed. The form still
 * shows them, but saves them through their own route and leaves them out of
 * the chart save. Mirrors MOVED_QIDS in the backend's
 * app/services/visit_task_detail_fields.py.
 */
export const TASK_DETAIL_QIDS: ReadonlySet<string> = new Set([
  'r_provided_cfc12d',
  'selectedQCode',
  'n_number_136917',
  't_hcpcs_7d3f2a',
]);

// The form questions each Task Details field is shown as.
const QIDS_BY_FIELD: Readonly<Record<string, readonly string[]>> = {
  site_of_service_code: ['r_provided_cfc12d', 'selectedQCode'],
  hcpcs_code_override: ['t_hcpcs_7d3f2a'],
  mileage: ['n_number_136917'],
};

/** The form questions that show the given Task Details fields. */
export function taskDetailQidsForFields(fields: readonly string[]): string[] {
  return fields.flatMap(field => QIDS_BY_FIELD[field] ?? []);
}

/** The answers without the Task Details questions: what a chart save sends. */
export function withoutTaskDetailAnswers(data: OASISFormData): OASISFormData {
  const chart: OASISFormData = {};
  Object.entries(data).forEach(([qid, value]) => {
    if (!TASK_DETAIL_QIDS.has(qid)) chart[qid] = value;
  });
  return chart;
}
